export default [
  {
    path: '/h5/yearly_pendant',
    component: () => import('./Page.vue'),
    meta: { title: '年度盛典挂件' },
  },
]

